import { MeiliSearch } from 'meilisearch';
import { SearchConfig } from './types';

export function createSearchClient(config: SearchConfig): MeiliSearch {
  return new MeiliSearch({
    host: config.host,
    apiKey: config.apiKey,
  });
}
